import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    MediaRenamer: {},
    MediaRenamerRoot: {
        zIndex: '9999999 !important',
    },
    MediaRenamerContent: {},
    MediaRenamerContentItem: {
        marginBottom: '1.6rem',
    },
    MediaRenamerContentAlert: {
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        background: theme.palette.lightGrey.main,
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        border: `1px solid ${theme.palette.lightGrey.half}`,
        borderRadius: '.7rem',
        padding: '1rem',
        width: '100%',
        marginBottom: '2rem',
        '& .MuiTypography-root': {
            marginBottom: '.7rem',
        },
    },
    MediaRenamerContentAlertRiskyChar: {
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        background: theme.palette.lightGrey.dark,
        margin: '0 .3rem',
        padding: '.2rem .7rem',
        borderRadius: 5,
    },
}))
